export default {
  primary: '#0a9000',
  secondary: '#424242',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107'
}


// WEBPACK FOOTER //
// ./webapp/theme.js